import React from 'react';
import Header from '../assets/header.png';
import '../styles/Home.css';

const Content = () => {
  return (
    <div className="container-header">
      <img src={Header} alt="" className="conteo" />
    </div>
  );
};

export default Content;
